module.exports = __webpack_public_path__ + "img/icon_social-media_instagram.da65913c.svg";